import React from 'react';

const ComputerMoney: React.FC = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 100 100" {...props}>
    <path
      fill="currentColor"
      d="M77.817 62.218h-55.75v-36.77h55.75v36.77zM81.237 20H18.763a2.406 2.406 0 00-2.405 2.376v42.885a2.405 2.405 0 002.405 2.405h22.89v8.693H29.92v3.274H68.4v-3.245H58.26v-8.693h22.977a2.405 2.405 0 002.405-2.405V22.376A2.405 2.405 0 0081.236 20z"
    ></path>
    <path
      fill="currentColor"
      d="M49.883 39.618h.29a1.913 1.913 0 011.68 1.912.84.84 0 001.68 0 3.593 3.593 0 00-2.636-3.477v-.84a.84.84 0 00-1.68 0v.782a3.593 3.593 0 00.724 7.128 1.913 1.913 0 11-1.913 1.913.84.84 0 10-1.68 0 3.593 3.593 0 002.897 3.535v.753a.84.84 0 101.681 0v-.811a3.594 3.594 0 00-.956-7.07 1.913 1.913 0 010-3.825h-.087z"
    ></path>
    <path
      fill="currentColor"
      stroke="currentColor"
      strokeMiterlimit="10"
      strokeWidth="1.557"
      d="M62.17 44.226a12.227 12.227 0 10-24.454 0 12.227 12.227 0 0024.454 0zM49.943 54.773a10.548 10.548 0 110-21.096 10.548 10.548 0 010 21.096z"
    ></path>
  </svg>
);

export default ComputerMoney;
